import { bfwIcon, bfwFooterIcon } from './bfwIcons';
import { macmillanLearningIcon } from './macmillanIcons';

// Main icons object
export const icons = {
  bfw: bfwIcon,
  bfwFooter: bfwFooterIcon,
  macmillanLearning: macmillanLearningIcon,
  macmillanLearningFooter: macmillanLearningIcon,
};